import "../styles/cards.scss";
import { useEffect, useRef } from "react";
import arrow from "../assets/img/arrow.png";

export function HomeCard4(props) {
    const main = useRef(null);
    const arr1 = useRef(null);
    const arr2 = useRef(null);
    useEffect(() => {
        if (props.active[props.num]) {
            main.current.style.display = "flex";
            // arr1.current.style.display = "flex";
            // arr2.current.style.display = "flex";
        } else {
            main.current.style.display = "none";
            // arr1.current.style.display = "none";
            // arr2.current.style.display = "none";
        }
    }, [props.active]);
    return (
        <div className="homeCard4" ref={main}>
            <div className="arrow l" ref={arr1} onClick={props.right}>
                <img src={arrow} style={{transform:"rotateZ(180deg) scaleX(-1)"}}></img>
            </div>
            <div className="main">
                <img className="i" src={props.img} />
                <div className="homeCard4Text"> {props.name}</div>
                <div className="homeCard4Text"> {props.text}</div>
            </div>
            <div className="arrow r" ref={arr2} onClick={props.left}>
            <img src={arrow} style={{transform:"rotateZ(180deg)"}}></img>
            </div>
        </div>
    );
}
